import React from 'react';
import toast from 'react-hot-toast';

export default function ShareExamModal({ exam, onClose }) {
  if (!exam) return null;

  const examLink = `${window.location.origin}/#/exam/${exam.link_token}`;
  const leaderboardLink = `${window.location.origin}/#/leaderboard/${exam.link_token}`;

  const copyLink = (link, label) => {
    navigator.clipboard.writeText(link);
    toast.success(`📋 ${label} copied!`);
  };

  const shareWhatsApp = () => {
    const msg = `📝 *${exam.title}* — take the exam here: ${examLink}`;
    window.open(`https://wa.me/?text=${encodeURIComponent(msg)}`);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 480 }}>
        <div className="flex-between" style={{ marginBottom: 20 }}>
          <h2>🔗 Share Exam</h2>
          <button
            onClick={onClose}
            style={{ background: 'none', border: 'none', color: 'var(--text2)', fontSize: 22, cursor: 'pointer' }}
          >✕</button>
        </div>

        <p style={{ fontWeight: 700, fontSize: 15, marginBottom: 16 }}>{exam.title}</p>

        <div style={{ marginBottom: 16 }}>
          <label style={{ fontSize: 13, color: 'var(--text2)', display: 'block', marginBottom: 6 }}>Exam link</label>
          <input
            readOnly
            value={examLink}
            onFocus={e => e.target.select()}
            style={{
              width: '100%', padding: '10px 12px', borderRadius: 8,
              border: '1px solid var(--border)', background: 'var(--card2)',
              color: 'var(--text)', fontFamily: 'var(--mono)', fontSize: 13,
              marginBottom: 10, boxSizing: 'border-box',
            }}
          />
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            <button onClick={() => copyLink(examLink, 'Link')} className="btn btn-primary btn-sm">🔗 Copy Link</button>
            <button onClick={shareWhatsApp} className="btn btn-success btn-sm">📱 Share on WhatsApp</button>
          </div>
        </div>

        <div style={{ marginBottom: 8 }}>
          <label style={{ fontSize: 13, color: 'var(--text2)', display: 'block', marginBottom: 6 }}>Leaderboard link</label>
          <input
            readOnly
            value={leaderboardLink}
            onFocus={e => e.target.select()}
            style={{
              width: '100%', padding: '10px 12px', borderRadius: 8,
              border: '1px solid var(--border)', background: 'var(--card2)',
              color: 'var(--text)', fontFamily: 'var(--mono)', fontSize: 13,
              marginBottom: 10, boxSizing: 'border-box',
            }}
          />
          <button onClick={() => copyLink(leaderboardLink, 'Leaderboard link')} className="btn btn-secondary btn-sm">🔗 Copy Leaderboard Link</button>
        </div>

        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 20 }}>
          <button onClick={onClose} className="btn btn-secondary btn-sm">Close</button>
        </div>
      </div>
    </div>
  );
}
